import { forwardRef } from "react";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { AccountDocument } from "../../../types";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { Button } from "devextreme-react";
import {
  ApiResponse,
  verfiyResponse,
} from "../../../../../redux/base/types/saga";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import notify from "devextreme/ui/notify";
import { getApiParams } from "../../../../../redux/auth";
import { disabled } from "../../../../../utils/helpers";
import {  imageUrl } from "../../../../../services/urls";


export const renderInformationItem = (item: any) => {
  if (item.editorOptions.value !== null) {
    return <span>{item.editorOptions.value}</span>;
  } else {
    return <span>-</span>;
  }
};

const AccountDocumentDetailModal = forwardRef<any, { data: AccountDocument }>(
  ({ data }, ref) => {

    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);

    return (
      <form>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            visible={!data?.Approved}
            text={localize.getString("approve")}
            className="datagrid-action-button"
            hint={localize.getString("approved")}
            icon="check"
            type="success"
            style={{ padding: 5 }}
            stylingMode="contained"
            onClick={async (e: any) => {

              const response: ApiResponse = await createRequest({
                method: "POST",
                url: "api/admin/accounts/approve-document",
                bodyType: BodyType.raw,
                token,
                body: { documentId: data.Id },
                lang,
              });
              if (  verfiyResponse(response)) {
                notify(response.Message, "success");
              } else notify(response.Message, "error");
            }}
          />
        </div>
        <Form
          ref={ref}
          key="id"
          labelLocation="left"
          formData={data}
          showColonAfterLabel={true}
        >
          <GroupItem colCount={2}>
            <GroupItem caption={"Doküman"}>
              <div style={{
                maxWidth : "250px",
                width : "100%"
              }}>
                <img src={imageUrl + data.DocumentLocation} alt="döküman" style={{maxWidth:"200px", width:"100%",objectFit:"contain"}}></img>
              </div>
            </GroupItem>
            <GroupItem caption={"Bilgiler"}>
              <SimpleItem
              
                dataField="AccountDocumentType"
                label={{
                  text: localize.getString("accountdocumenttype"),
                }}
                render={renderInformationItem}
              />
              <SimpleItem
                dataField="Approved"
                label={{
                  text: localize.getString("approved"),
                }}
                editorType={"dxCheckBox"}
                editorOptions={disabled}
              />
            </GroupItem>
          </GroupItem>
        </Form>
      </form>
    );
  }
);

export default AccountDocumentDetailModal;
